module.exports = __webpack_public_path__ + "static/img_1-ade57bd4178ea82102ca177ebb43898a.svg";